import InputFilterItem from './InputFilterItem';
import ListFilterItem from './ListFilterItem';
import CityFilterItem from './CityFilterItem';

const fields = { InputFilterItem, ListFilterItem, CityFilterItem };

export default fields;
